import { render, staticRenderFns } from "./security_dashboard.vue?vue&type=template&id=ca2d65da&"
import script from "./security_dashboard.vue?vue&type=script&lang=js&"
export * from "./security_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports